function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MOLECULES/Other/trending-bad",
  transform: "translate(0.000000, -2.000000)",
  fill: "#C20000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 7.500000) scale(1, -1) translate(-4.000000, -7.500000) translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(4.000000, 6.190863) scale(1, -1) translate(-4.000000, -6.190863) ",
  x: 3,
  y: 1.38172567,
  width: 2,
  height: 9.61827433
}), /*#__PURE__*/React.createElement("g", {
  id: "ATOMS/icons/arrow-down",
  transform: "translate(4.000000, 2.343750) scale(1, -1) translate(-4.000000, -2.343750) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5,0.46875 L4,2.8125 L4,2.8125 L6.5,0.46875 C6.7812071,0.205118347 7.2187929,0.205118347 7.5,0.46875 C7.75888348,0.711453259 7.77200013,1.11806965 7.52929688,1.37695312 C7.51984873,1.38703115 7.51007802,1.39680185 7.5,1.40625 L4.51295585,4.20660389 C4.2244622,4.47706669 3.7755378,4.47706669 3.48704415,4.20660389 L0.5,1.40625 C0.241116524,1.16354674 0.227999866,0.756930351 0.470703125,0.498046875 C0.480151273,0.487968851 0.489921976,0.478198148 0.5,0.46875 C0.781207097,0.205118347 1.2187929,0.205118347 1.5,0.46875 Z",
  id: "Rectangle-Copy-17"
})))));

function SvgDaxArrowRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxArrowRed);
export default __webpack_public_path__ + "static/media/dax-arrow-red.33b7749b.svg";
export { ForwardRef as ReactComponent };